import { Controller } from "@hotwired/stimulus"

// Handles copying text to clipboard
export default class extends Controller {
  static targets = ["content", "source", "buttonText"]

  async copy(event) {
    event.preventDefault()

    let textToCopy = ""

    // Try to get content from data-content attribute first, then from content target
    if (event.currentTarget.dataset.content) {
      textToCopy = event.currentTarget.dataset.content
    } else if (this.hasContentTarget) {
      textToCopy = this.contentTarget.textContent
    }

    if (!textToCopy) {
      console.error("No content to copy")
      return
    }

    try {
      await navigator.clipboard.writeText(textToCopy)
      this.showCopiedFeedback()
    } catch (error) {
      // Fallback for older browsers
      this.fallbackCopy(textToCopy)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy")
      this.showCopiedFeedback()
    } catch (error) {
      console.error("Fallback copy failed:", error)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showCopiedFeedback() {
    if (this.hasButtonTextTarget) {
      const originalText = this.buttonTextTarget.textContent
      this.buttonTextTarget.textContent = "Copied!"

      setTimeout(() => {
        this.buttonTextTarget.textContent = originalText
      }, 2000)
    }
  }
}
